import styled from '@emotion/styled'

export const SkeletonTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`
